import { useTranslation } from "react-i18next"
import { Form, Row, Col, Button } from "react-bootstrap"
import Select from "react-select"
import { getCauseOptions } from "../../../constants/causeOptions"
import { getConfirmationOptions } from "../../../constants/confirmationOptions"
import { getDestinationOptions } from "../../../constants/destinationOptions"
import { getForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'
import { getForSelect as getLotsForSelect } from '../../../actions/other/lotsActions'
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"

export default function EventFormBaja({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)
	const { lotsForSelect } = useSelector(state => state.lots)

    const causeOptions = getCauseOptions(t)
    const confirmationOptions = getConfirmationOptions(t)
    const destinationOptions = getDestinationOptions(t)

	const showCause = ['death', 'sacrifice', 'desvieje'].includes(type)
	const showConfirmation = ['death', 'sacrifice'].includes(type)
	const showDestination = ['sacrifice', 'desvieje', 'sale'].includes(type)
	const showPriceWeight = ['sacrifice', 'desvieje', 'sale'].includes(type)

	const titleMap = {
		death: t('menus.event_death'),
		sacrifice: t('menus.event_sacrifice'),
		desvieje: t('menus.event_desvieje'),
		sale: t('menus.event_sale'),
	}

	useEffect(() => {
		dispatch(getAnimalsForSelect())
		dispatch(getLotsForSelect())
	}, [dispatch])

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{titleMap[type] || t('admin.event.baja')}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.exitDate')}</Form.Label>
						<Form.Control
							type="date"
							name="exitDate"
							value={state?.exitDate || ''}
							onChange={handleInputChange}
							required
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				{['death', 'sacrifice'].includes(type) && (
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.animal.animal')}</Form.Label>
							<Select
								options={animalsForSelect?.map(m => ({ value: m._id, label: m.identifier }))}
								value={animalsForSelect?.find(f => f._id === state?.animals?.[0])
									? { value: state.animals[0], label: animalsForSelect.find(f => f._id === state.animals[0])?.identifier }
									: null}
								onChange={opt => handleInputChange({ target: { name: 'animals', value: opt ? [opt.value] : [] } })}
							/>
						</Form.Group>
					</Col>
				)}

				{['desvieje', 'sale'].includes(type) && (
					<>
						<Col md={6}>
							<Form.Group>
								<Form.Label>{t('admin.animal.animals')}</Form.Label>
								<Select
									isMulti
									options={animalsForSelect?.map(m => ({ value: m._id, label: m.identifier }))}
									value={animalsForSelect
										.filter(f => state.animals?.includes(f._id))
										.map(f => ({ value: f._id, label: f.identifier }))}
									onChange={opts => handleInputChange({ target: { name: 'animals', value: opts ? opts.map(o => o.value) : [] } })}
									isClearable
								/>
							</Form.Group>
						</Col>

						<Col md={6}>
							<Form.Group>
								<Form.Label>{t('admin.animal.lots')}</Form.Label>
								<Select
									isMulti
									options={lotsForSelect?.map(l => ({ value: l._id, label: l.identifier }))}
									value={lotsForSelect
										.filter(l => state.lots?.includes(l._id))
										.map(l => ({ value: l._id, label: l.identifier }))}
									onChange={opts => handleInputChange({ target: { name: 'lots', value: opts ? opts.map(o => o.value) : [] } })}
									isClearable
								/>
							</Form.Group>
						</Col>
					</>
				)}

				<Col md={6}>
					{showCause && (
						<Form.Group>
							<Form.Label>{t('admin.event.cause')}</Form.Label>
							<Select
								options={causeOptions}
								value={causeOptions.find(o => o.value === state.cause) || null}
								onChange={opt => handleInputChange({ target: { name: 'cause', value: opt.value } })}
							/>
						</Form.Group>
					)}

					{showConfirmation && (
						<Form.Group>
							<Form.Label>{t('admin.event.cause_confirmation')}</Form.Label>
							<Select
								options={confirmationOptions}
								value={confirmationOptions.find(o => o.value === state.causeConfirmed) || null}
								onChange={opt => handleInputChange({ target: { name: 'causeConfirmed', value: opt.value } })}
							/>
						</Form.Group>
					)}
				</Col>
			</Row>

			<Row className="my-2">
				{showDestination && (
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.event.destination')}</Form.Label>
							<Select
								options={destinationOptions}
								value={destinationOptions.find(o => o.value === state.destination) || null}
								onChange={opt => handleInputChange({ target: { name: 'destination', value: opt.value } })}
							/>
						</Form.Group>
					</Col>
				)}
			</Row>

			{showPriceWeight && (
				<Row className="my-2">
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.event.salePrice')} (€)</Form.Label>
							<Form.Control
								type="number"
								name="price"
								value={state.price || ''}
								onChange={handleInputChange}
								min="0"
								step="0.01"
							/>
						</Form.Group>
					</Col>
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.animal.weight')} (kg)</Form.Label>
							<Form.Control
								type="number"
								name="weight"
								value={state.weight || ''}
								onChange={handleInputChange}
								min="0"
								step="0.01"
							/>
						</Form.Group>
					</Col>
				</Row>
			)}

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}

